const events = [];

window.goatcounter = {no_onload: true};

window.goatevent = (event) => {
	if (window.goatcounter.count) {
		window.goatcounter.count(event);
	} else if (events.length < 10) {
		events.push(event);
	}
};

(() => {
	const script = document.createElement("script");
	const node = document.getElementsByTagName("script")[0];
	script.setAttribute("data-goatcounter", "https://y.mxrlkn.com/count");
	script.src = "https://y.mxrlkn.com/count.js";
	script.async = true;
	script.onload = () => {
		events.forEach((x) => window.goatcounter.count(x));
	};
	node.parentNode.insertBefore(script, node);
})();
